import iconThemeColor from "../index";

const MaximizeIcon = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 7.5C5.72386 7.5 5.5 7.72386 5.5 8C5.5 8.27614 5.72386 8.5 6 8.5H18C18.2761 8.5 18.5 8.27614 18.5 8C18.5 7.72386 18.2761 7.5 18 7.5H6Z"
        fill={fillColor}
      />
      <path
        d="M5.5 12C5.5 11.7239 5.72386 11.5 6 11.5H18C18.2761 11.5 18.5 11.7239 18.5 12C18.5 12.2761 18.2761 12.5 18 12.5H6C5.72386 12.5 5.5 12.2761 5.5 12Z"
        fill={fillColor}
      />
      <path
        d="M5.5 16C5.5 15.7239 5.72386 15.5 6 15.5H18C18.2761 15.5 18.5 15.7239 18.5 16C18.5 16.2761 18.2761 16.5 18 16.5H6C5.72386 16.5 5.5 16.2761 5.5 16Z"
        fill={fillColor}
      />
    </svg>
  );
};

const MinimizeIcon = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 7.5C3.72386 7.5 3.5 7.72386 3.5 8C3.5 8.27614 3.72386 8.5 4 8.5H15C15.2761 8.5 15.5 8.27614 15.5 8C15.5 7.72386 15.2761 7.5 15 7.5H4Z"
        fill={fillColor}
      />
      <path
        d="M4 11.5C3.72386 11.5 3.5 11.7239 3.5 12C3.5 12.2761 3.72386 12.5 4 12.5H12C12.2761 12.5 12.5 12.2761 12.5 12C12.5 11.7239 12.2761 11.5 12 11.5H4Z"
        fill={fillColor}
      />
      <path
        d="M3.5 16C3.5 15.7239 3.72386 15.5 4 15.5H15C15.2761 15.5 15.5 15.7239 15.5 16C15.5 16.2761 15.2761 16.5 15 16.5H4C3.72386 16.5 3.5 16.2761 3.5 16Z"
        fill={fillColor}
      />
      <path
        d="M19.1464 8.14645C19.3417 7.95118 19.6583 7.95118 19.8536 8.14645C20.0488 8.34171 20.0488 8.65829 19.8536 8.85355L16.7071 12L19.8536 15.1464C20.0488 15.3417 20.0488 15.6583 19.8536 15.8536C19.6583 16.0488 19.3417 16.0488 19.1464 15.8536L15.6464 12.3536C15.5527 12.2598 15.5 12.1326 15.5 12C15.5 11.8674 15.5527 11.7402 15.6464 11.6464L19.1464 8.14645Z"
        fill={fillColor}
      />
    </svg>
  );
};

const BoltLightningIcon = ({ fillColor, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.42024 4.25746C7.53153 3.8123 7.93152 3.5 8.39039 3.5H15.3901C16.0211 3.5 16.4944 4.07733 16.3707 4.69612L15.6099 8.5H18.9219C19.7733 8.5 20.2353 9.49603 19.6853 10.1459L10.9319 20.4909C10.2316 21.3185 8.89917 20.5961 9.2107 19.5576L11.328 12.5H6.64039C5.98981 12.5 5.51246 11.8886 5.67024 11.2575L7.42024 4.25746ZM15.3901 4.5H8.39039L6.64039 11.5H11.328C11.9978 11.5 12.4783 12.1457 12.2858 12.7873L10.1685 19.8449L18.9219 9.5L15.6099 9.5C14.9789 9.5 14.5056 8.92268 14.6293 8.30388L15.3901 4.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

const CubeIcon = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4091 4.70925C11.7864 4.54754 12.2136 4.54754 12.5909 4.70925L19.197 7.54043C19.3808 7.61922 19.5 7.79999 19.5 8V15.3406C19.5 15.9406 19.1424 16.483 18.5909 16.7193L12.197 19.4596C12.0712 19.5135 11.9288 19.5135 11.803 19.4596L5.40912 16.7193C4.8576 16.483 4.5 15.9406 4.5 15.3406V8C4.5 7.79999 4.6192 7.61922 4.80304 7.54043L11.4091 4.70925ZM12.197 5.62839C12.0712 5.57449 11.9288 5.57449 11.803 5.62839L6.2693 8L12 10.456L17.7307 8L12.197 5.62839ZM18.5 8.75827L12.5 11.3297V18.2417L18.197 15.8002C18.3808 15.7214 18.5 15.5406 18.5 15.3406V8.75827ZM11.5 18.2417V11.3297L5.5 8.75827V15.3406C5.5 15.5406 5.6192 15.7214 5.80304 15.8002L11.5 18.2417Z"
        fill={fillColor}
      />
    </svg>
  );
};

const ToggleOnIcon = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 7.5C6.01472 7.5 4 9.51472 4 12C4 14.4853 6.01472 16.5 8.5 16.5H15.5C17.9853 16.5 20 14.4853 20 12C20 9.51472 17.9853 7.5 15.5 7.5H8.5ZM15.5 15C17.1569 15 18.5 13.6569 18.5 12C18.5 10.3431 17.1569 9 15.5 9C13.8431 9 12.5 10.3431 12.5 12C12.5 13.6569 13.8431 15 15.5 15Z"
        fill={fillColor}
      />
    </svg>
  );
};

const ConnectorIcon = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.99999 7.5C5.61928 7.5 4.49999 8.61929 4.49999 10V11.5433C3.98168 11.6376 3.56752 11.8822 3.25496 12.2428C2.86571 12.692 2.67112 13.2782 2.5701 13.8506C2.42077 14.6968 2.45717 15.6799 2.48382 16.3994C2.49241 16.6315 2.49999 16.8362 2.49999 17C2.49999 17.2761 2.72385 17.5 2.99999 17.5C3.27613 17.5 3.49999 17.2761 3.49999 17C3.49999 16.7734 3.49082 16.5233 3.48112 16.2591C3.45537 15.5573 3.42594 14.7551 3.55488 14.0244C3.64137 13.5343 3.79052 13.1518 4.01065 12.8978C4.13241 12.7573 4.28796 12.6417 4.49999 12.572V14C4.49999 15.3807 5.61928 16.5 6.99999 16.5H9.49999C10.0523 16.5 10.5 16.0523 10.5 15.5V14.25H11.5C11.9142 14.25 12.25 13.9142 12.25 13.5C12.25 13.0858 11.9142 12.75 11.5 12.75H10.5V11.25H11.5C11.9142 11.25 12.25 10.9142 12.25 10.5C12.25 10.0858 11.9142 9.75 11.5 9.75H10.5V8.5C10.5 7.94772 10.0523 7.5 9.49999 7.5H6.99999ZM5.49999 10C5.49999 9.17157 6.17157 8.5 6.99999 8.5H9.49999V15.5H6.99999C6.17157 15.5 5.49999 14.8284 5.49999 14V10Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5 7.5C13.9477 7.5 13.5 7.94772 13.5 8.5V15.5C13.5 16.0523 13.9477 16.5 14.5 16.5H17C18.3807 16.5 19.5 15.3807 19.5 14V12.4645C20.1756 12.3645 20.7784 12.0456 21.2221 11.4117C21.747 10.6619 22 9.53798 22 8C22 7.72386 21.7761 7.5 21.5 7.5C21.2239 7.5 21 7.72386 21 8C21 9.46202 20.753 10.3381 20.4029 10.8383C20.1723 11.1676 19.8762 11.3631 19.5 11.4486V10C19.5 8.61929 18.3807 7.5 17 7.5H14.5ZM14.5 8.5H17C17.8284 8.5 18.5 9.17157 18.5 10V14C18.5 14.8284 17.8284 15.5 17 15.5H14.5V8.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

const ConnectorIconPlus = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.5404 6.5C21.5404 6.22386 21.3166 6 21.0404 6C20.7643 6 20.5404 6.22386 20.5404 6.5C20.5404 7.96202 20.2935 8.83806 19.9433 9.33827C19.7128 9.66761 19.4166 9.86308 19.0404 9.9486V9.5C19.0404 8.11929 17.9211 7 16.5404 7H14.0404C13.4881 7 13.0404 7.44772 13.0404 8V13C13.0404 13.1742 13.085 13.338 13.1633 13.4806C13.4219 13.195 13.7167 12.9427 14.0404 12.731V8H16.5404C17.3689 8 18.0404 8.67157 18.0404 9.5V11.5C18.0404 11.7568 17.9759 11.9985 17.8622 12.2099C18.1844 12.3121 18.4909 12.4496 18.7772 12.6179C18.9456 12.2815 19.0404 11.9018 19.0404 11.5V10.9645C19.716 10.8645 20.3188 10.5456 20.7625 9.91173C21.2874 9.16194 21.5404 8.03798 21.5404 6.5Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.54043 7C5.15972 7 4.04043 8.11929 4.04043 9.5V10.0433C3.52212 10.1376 3.10795 10.3822 2.7954 10.7428C2.40615 11.192 2.21155 11.7782 2.11054 12.3506C1.96121 13.1968 1.99761 14.1799 2.02425 14.8994C2.03285 15.1315 2.04043 15.3362 2.04043 15.5C2.04043 15.7761 2.26429 16 2.54043 16C2.81657 16 3.04043 15.7761 3.04043 15.5C3.04043 15.2734 3.03125 15.0233 3.02156 14.7591C2.99581 14.0573 2.96638 13.2551 3.09532 12.5244C3.1818 12.0343 3.33096 11.6518 3.55109 11.3978C3.67284 11.2573 3.82839 11.1417 4.04043 11.072V11.5C4.04043 12.8807 5.15972 14 6.54043 14H9.04043C9.59271 14 10.0404 13.5523 10.0404 13V12.75H11.0404C11.4546 12.75 11.7904 12.4142 11.7904 12C11.7904 11.5858 11.4546 11.25 11.0404 11.25H10.0404V9.75H11.0404C11.4546 9.75 11.7904 9.41421 11.7904 9C11.7904 8.58579 11.4546 8.25 11.0404 8.25H10.0404V8C10.0404 7.44771 9.59271 7 9.04043 7H6.54043ZM5.04043 9.5C5.04043 8.67157 5.712 8 6.54043 8H9.04043V13H6.54043C5.712 13 5.04043 12.3284 5.04043 11.5V9.5Z"
        fill={fillColor}
      />
      <path
        d="M17 14.5C17 14.2239 16.7761 14 16.5 14C16.2239 14 16 14.2239 16 14.5V16H14.5C14.2239 16 14 16.2239 14 16.5C14 16.7761 14.2239 17 14.5 17H16V18.5C16 18.7761 16.2239 19 16.5 19C16.7761 19 17 18.7761 17 18.5V17H18.5C18.7761 17 19 16.7761 19 16.5C19 16.2239 18.7761 16 18.5 16H17V14.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

const HighlightOffIcon = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.35355 8.64645C9.15829 8.45118 8.84171 8.45118 8.64645 8.64645C8.45118 8.84171 8.45118 9.15829 8.64645 9.35355L11.2929 12L8.64645 14.6464C8.45118 14.8417 8.45118 15.1583 8.64645 15.3536C8.84171 15.5488 9.15829 15.5488 9.35355 15.3536L12 12.7071L14.6464 15.3536C14.8417 15.5488 15.1583 15.5488 15.3536 15.3536C15.5488 15.1583 15.5488 14.8417 15.3536 14.6464L12.7071 12L15.3536 9.35355C15.5488 9.15829 15.5488 8.84171 15.3536 8.64645C15.1583 8.45118 14.8417 8.45118 14.6464 8.64645L12 11.2929L9.35355 8.64645Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C16.1421 4.5 19.5 7.85786 19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C7.85786 19.5 4.5 16.1421 4.5 12Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ThemedBoltLightningIcon = iconThemeColor(BoltLightningIcon);
export const ThemedMaximizeIcon = iconThemeColor(MaximizeIcon);
export const ThemedMinimizeIcon = iconThemeColor(MinimizeIcon);
export const ThemedCubeIcon = iconThemeColor(CubeIcon);
export const ThemedToggleOnIcon = iconThemeColor(ToggleOnIcon);
export const ThemedHighlightOffIcon = iconThemeColor(HighlightOffIcon);
export const ThemedConnectorIcon = iconThemeColor(ConnectorIcon);
export const ThemedConnectorIconPlus = iconThemeColor(ConnectorIconPlus);
